import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Tag, Plus, X } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useTags } from "@/context/AuthContext";
import { Card } from "@/components/settings/Card";

const COLORS = ["#3B82F6", "#25D366", "#EF4444", "#F59E0B", "#A855F7", "#64748B"];

export const TagsSettings = () => {
  const qc = useQueryClient();
  const { data: tags = [] } = useTags();
  const [name, setName] = useState("");
  const [color, setColor] = useState(COLORS[0]);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/tags", { name, color }); setName(""); qc.invalidateQueries({ queryKey: ["tags"] }); toast.success("Tag creato"); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (id) => { await api.delete(`/tags/${id}`); qc.invalidateQueries({ queryKey: ["tags"] }); qc.invalidateQueries({ queryKey: ["conversations"] }); };
  return (
    <Card testid="tags-card" title="Tag personalizzati" desc="Usati per filtrare la casella e classificare i clienti" icon={Tag}>
      <form onSubmit={add} className="flex gap-3 items-center">
        <Input data-testid="tag-name-input" required placeholder="Nome tag" value={name} onChange={(e) => setName(e.target.value)} className="max-w-xs" />
        <div className="flex gap-1.5">{COLORS.map((c) => <button type="button" key={c} onClick={() => setColor(c)} className={`w-6 h-6 rounded-full ${color === c ? "ring-2 ring-offset-2 ring-slate-900" : ""}`} style={{ background: c }} />)}</div>
        <Button data-testid="tag-add-button" type="submit" className="ml-auto bg-[#0F172A] hover:bg-[#1E293B]"><Plus size={15} className="mr-1.5" />Aggiungi</Button>
      </form>
      <div className="flex flex-wrap gap-2 mt-6">
        {tags.map((t) => (
          <span key={t.id} data-testid={`tag-chip-${t.name.toLowerCase()}`} className="text-sm font-medium pl-3 pr-1.5 py-1 rounded-full text-white flex items-center gap-1.5" style={{ background: t.color }}>
            {t.name}
            <button data-testid={`tag-delete-${t.name.toLowerCase()}`} onClick={() => remove(t.id)} className="w-5 h-5 rounded-full hover:bg-black/20 grid place-items-center"><X size={12} /></button>
          </span>
        ))}
      </div>
    </Card>
  );
};
